export default __webpack_public_path__ + "static/media/dieppe22.b589b43d.jpg";